module.exports = __webpack_public_path__ + "static/media/colourOptions5.55e8263c.PNG";